import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

type Props = {
  emittedEventDefs: any[];
  maxHeight?: number;
};

const EmittedEventDefs = ({ emittedEventDefs = [] }: Props) => {
  return (
    <Box sx={{ overflowY: 'auto' }}>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell sx={{ borderRight: '1px solid', borderColor: 'divider' }}>Event name</TableCell>
              <TableCell sx={{ borderRight: '1px solid', borderColor: 'divider' }}>Event label</TableCell>
              <TableCell sx={{ borderRight: '1px solid', borderColor: 'divider' }}>Event type</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(emittedEventDefs || []).map((emittedEventDef: any, idx: any) => (
              <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} key={idx}>
                <TableCell>{emittedEventDef.eventName}</TableCell>
                <TableCell>{emittedEventDef.eventLabel}</TableCell>
                <TableCell>{emittedEventDef.eventType}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default EmittedEventDefs;
